import React from 'react'
import Navbar from '../Navbar'
import Footer from '../footer/Footer'
import bannerimg from '../../assets/images/bg.png'
import img1 from '../../assets/images/1.png'
import img2 from '../../assets/images/2.png'
import img3 from '../../assets/images/Arrow.png'
import InitialSWOTHook from './initialSWOTHook'
import { useLocation } from 'react-router-dom'

const InitialSWOT = () => {
    const { handleSave, marksData, toggleModal, showModal, formDataValue, handleOnChange,
        showModal2, toggleModal2
    } = InitialSWOTHook()
    const location = useLocation();
    const { initialData1, initialData2 } = location.state || {};
    const adaptiveModule = initialData2?.["Adaptive Module"] || "No Data Available";
    return (
        <div>
            <Navbar />
            <div className='pt-3 innerBg'>
                {/* <img src={bannerimg} style={{ width: "100%" }}></img> */}
                <h1 style={{ color: 'white', fontWeight: '600' }}>Initial SWOT</h1>
            </div>

            {initialData1?.status == true ? (
                <div className='py-5 my-3'>
                    <div className='querycard'>
                        <div>
                            <div className='row '>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    <div className=' '>
                                        <div className='text-center' style={{ backgroundColor: "#89D78E", borderRadius: "12px" }}>
                                            <h2 className='py-4 fw white'>{initialData1.data.eng_mark}</h2>
                                            <h4 className='pb-4 fw white'>{initialData1.data.subject_english}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    <div className=' '>
                                        <div className='text-center' style={{ backgroundColor: "#FD9DA7", borderRadius: "12px" }}>
                                            <h2 className='py-4 fw white'>{initialData1.data.math_mark}</h2>
                                            <h4 className='pb-4 fw white'>{initialData1.data.subject_maths}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    <div className=' '>
                                        <div className='text-center' style={{ backgroundColor: "#C5E0A7", borderRadius: "12px" }}>
                                            <h2 className='py-4 fw white'>{initialData1.data.goal_clarity}</h2>
                                            <h4 className='pb-4 fw white'>{initialData1.data.subject_goal_clarity}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-12'>
                                    <div className=' '>
                                        <div className='text-center' style={{ backgroundColor: "#A83942", borderRadius: "12px" }}>
                                            <h2 className='py-4 fw white'>{initialData1.data.communication_mark}</h2>
                                            <h4 className='pb-4 fw white'>{initialData1.data.subject_communication}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='pt-5 mt-4'>
                                <div className='bottombtn text-center'>
                                    <div>
                                        <h3 className='text-color fw py-2'>Your Adaptive Module</h3>
                                        <h5 className='basecolor fw'>{adaptiveModule} </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
                :
                (
                    <div>
                        <div className='mt-3 pt-3'>
                            <h4 className='text-center text-color category'><strong>Please enter the scores of your initial SWOT</strong></h4>
                        </div>
                        <div className='py-5 my-3'>
                            <div className='querycard'>
                                <div>
                                    <div className='row '>
                                        <div className='col'>
                                            <div className=' querycarddiv'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='d-flex'>
                                                        <p style={{ padding: "10px 20px  0px" }} className='basecolor fw'>English</p>
                                                    </div>
                                                    <div>
                                                        <input type='number' className='form-control marks' placeholder='Enter Marks'
                                                            value={formDataValue.english} onChange={handleOnChange} name='english' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col'>
                                            <div className=' querycarddiv'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='d-flex'>
                                                        <p style={{ padding: "10px 20px  0px" }} className='basecolor fw'>Maths & Reasoning</p>
                                                    </div>
                                                    <div>
                                                        <input type='number' className='form-control marks' placeholder='Enter Marks'
                                                            value={formDataValue.math} onChange={handleOnChange} name='math' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pt-4'>
                                        <div className='col'>
                                            <div className=' querycarddiv'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='d-flex'>
                                                        <p style={{ padding: "10px 20px  0px" }} className='basecolor fw'>Communication</p>
                                                    </div>
                                                    <div>
                                                        <input type='number' className='form-control marks' placeholder='Enter Marks'
                                                            value={formDataValue.communication} onChange={handleOnChange} name='communication' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col'>
                                            <div className=' querycarddiv'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='d-flex'>
                                                        <p style={{ padding: "10px 20px  0px" }} className='basecolor fw'>Goal Clarity</p>
                                                    </div>
                                                    <div>
                                                        <input type='number' className='form-control marks' placeholder='Enter Marks'
                                                            value={formDataValue.goal_clarity} onChange={handleOnChange} name='goal_clarity' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-5'><button className='btn btn-primary loginBtn2' onClick={handleSave}>Save</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            <div>
                {showModal && (
                    <div>
                        <div
                            className="modal-backdrop"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 1040,
                            }}
                        ></div>
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header d-flex justify-content-end">
                                        <h5 className="modal-title"></h5>
                                        <button type="button" className="close" onClick={toggleModal} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body text-center">
                                        You had already submitted your SWOT.
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary loginBtn2" onClick={toggleModal}>
                                            ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showModal2 && (
                    <div>
                        <div
                            className="modal-backdrop"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 1040,
                            }}
                        ></div>
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header d-flex justify-content-end">
                                        <h5 className="modal-title"></h5>
                                        <button type="button" className="close" onClick={toggleModal2} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body text-center">
                                        Please enter the scored of your initial swot marks.
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary loginBtn2" onClick={toggleModal2}>
                                            ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    )
}

export default InitialSWOT
